

















import { BehaviorHashtagKeywordSearchInfo, BehaviorTag } from '@tt4b/ttam-enums';
import { defineComponent, PropType } from '@vue/composition-api';

const name = 'ttam-tags-container';
export default defineComponent({
  props: {
    tags: {
      type: Array as PropType<Array<BehaviorTag & BehaviorHashtagKeywordSearchInfo>>,
      default: () => [],
    },
    disabled: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const onTagClose = (item: BehaviorTag & BehaviorHashtagKeywordSearchInfo) => {
      emit('close-one', item);
    };
    return {
      name,
      onTagClose,
    };
  },
});
